import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Dehumidifier Icon Style 04 - Waves (Material Symbol)
 */
export const Style04_Waves: React.FC<DeviceIconProps> = ({
  isOn = false,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-blue-400' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      waves
    </span>
  );
};

export default Style04_Waves;
